const mspBillingPlanSchema = {
  $id: "/mspbillingplan",
  type: "object",
  properties: {
    id: { type: "string", format: "uuid", readOnly: true },
    planId: { type: "string", createOnly: true },
    orgId: { type: "string", format: "uuid", readOnly: true },
    rampId: { type: "string", format: "uuid", readOnly: true },
    createdBy: { type: "string", readOnly: true },
    created: { type: "string", format: "date-time", readOnly: true },
    modified: { type: "string", format: "date-time", readOnly: true },
    modifiedBy: { type: "string", readOnly: true },
    deleted: { type: "string", format: "date-time", readOnly: true },
    deletedBy: { type: "string", readOnly: true },
    termEnd: { type: "string", format: "date-time" },
    autoRenew: { type: "boolean" },
    billingPlan: {
      type: "object",
      properties: {
        id: { type: "string", format: "uuid", readOnly: true },
        tier: { type: "number" },
        name: { type: "string" },
      },
    },
    ramp: {
      type: "object",
      properties: {
        id: { type: "string", format: "uuid", readOnly: true },
        monthOneMin: { type: "number" },
        monthTwoMin: { type: "number" },
        monthThreeMin: { type: "number" },
        monthFourMin: { type: "number" },
        monthFiveMin: { type: "number" },
        monthSixMin: { type: "number" },
        defaultMin: { type: "number" },
      },
    },
    billingPlanLicenses: {
      type: "array",
      items: {
        type: "object",
        properties: {
          id: { type: "string", format: "uuid", readOnly: true },
          itemName: { type: "string" },
          itemPrice: { type: "string" },
        },
      },
    },
  },
  // required: ["ruleId", "queryParams"],
  additionalProperties: false,
};

export default mspBillingPlanSchema;
